import IconItem from './icon_item';

export default class Chart extends IconItem {
  constructor() {
    super('chart');
  }
}
